import type { ActionType } from '@/types'

export interface ActionTypeDefinition {
  type: ActionType
  icon: string
  label: string
  description: string
  apRange: [number, number]
  hasWarning?: boolean
  warningText?: string
}

export const ACTION_TYPE_DEFINITIONS: ActionTypeDefinition[] = [
  {
    type: 'campaign',
    icon: '🎯',
    label: 'Campaign',
    description: 'Run ads, rallies, and canvassing to win support',
    apRange: [1, 5],
  },
  {
    type: 'fundraise',
    icon: '💰',
    label: 'Fundraise',
    description: 'Solicit donors aligned with your ideology',
    apRange: [1, 3],
  },
  {
    type: 'poll',
    icon: '📊',
    label: 'Poll',
    description: 'Research voter preferences and identify battlegrounds',
    apRange: [1, 4],
  },
  {
    type: 'recruit',
    icon: '👤',
    label: 'Recruit',
    description: 'Scout and sign new candidates to your party',
    apRange: [1, 2],
  },
  {
    type: 'attack',
    icon: '⚔️',
    label: 'Attack',
    description: 'Undermine rival parties with negative campaigning',
    apRange: [2, 5],
    hasWarning: true,
    warningText: 'Reputation risk',
  },
  {
    type: 'pr',
    icon: '📢',
    label: 'PR',
    description: 'Shape narrative and control your messaging',
    apRange: [1, 3],
  },
  {
    type: 'internal',
    icon: '🏛️',
    label: 'Internal',
    description: 'Manage party loyalty and faction disputes',
    apRange: [1, 2],
  },
  {
    type: 'organize',
    icon: '🗂️',
    label: 'Organize',
    description: 'Build local volunteer networks and infrastructure',
    apRange: [2, 4],
  },
] as const

export const getActionTypeDefinition = (
  type: ActionType
): ActionTypeDefinition | undefined => {
  return ACTION_TYPE_DEFINITIONS.find((def) => def.type === type)
}

export const getActionTypeIcon = (type: ActionType): string => {
  return getActionTypeDefinition(type)?.icon ?? '❓'
}

export const getActionTypeLabel = (type: ActionType): string => {
  return getActionTypeDefinition(type)?.label ?? type
}
